import React, { useRef, useState, useEffect } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { authStore } from '../shared/security/AuthStore';
import { Header } from 'components/layout/header/Header';
import SideNavigation from 'ats/components/side-navigation/SideNavigation';
import { Pipeline } from 'ats/pages/pipeline/Pipeline';
import { JobPositions } from 'ats/pages/job-positions/JobPositions';
import { Applicants } from 'ats/pages/applicants/Applicants';
import { Clients } from 'ats/pages/clients/Clients';
import { ExternalApplications } from 'ats/pages/external-applications/ExternalApplications';
import SettingsApp from './SettingsApp';
import { CandidateProfile } from 'components/candidates/profile/CandidateProfile';
import { RoleRoute } from 'shared/security/RoleRoute';
import { getDefaultAtsPath } from 'shared/security/rolePermissions';

const ATS_SIDEBAR_GAP = 16;

const ATSRoutes = ({ match }) => {
	const sideNavigationRef = useRef(null);
	const [sideNavigationWidth, setSideNavigationWidth] = useState(0);

	useEffect(() => {
		const element = sideNavigationRef.current;

		if (!element) return;

		const resizeObserver = new ResizeObserver(entries => {
			for (let entry of entries) {
				setSideNavigationWidth(entry.target.clientWidth);
			}
		});

		resizeObserver.observe(element);

		return () => {
			resizeObserver.disconnect();
		};
	}, []);

	return (
		<>
			<Header />
			<div className="ATS" style={{ gap: ATS_SIDEBAR_GAP }}>
				<SideNavigation basePath={match.path} ref={sideNavigationRef} />
				<div
					className="main-content"
					style={{
						width: `calc(100% - ${sideNavigationWidth}px - ${ATS_SIDEBAR_GAP}px)`
					}}>
					<Route exact path={match.path}>
						<Redirect
							to={`${match.path}${getDefaultAtsPath().replace('/ats', '')}`}
						/>
					</Route>
					<RoleRoute path={`${match.path}/pipeline`}>
						{auth(<Pipeline />)}
					</RoleRoute>
					<RoleRoute path={`${match.path}/jobs/:id?`}>
						{auth(<JobPositions />)}
					</RoleRoute>
					<RoleRoute path={`${match.path}/candidates/:id?`} exact>
						{auth(<Applicants />)}
					</RoleRoute>
					<RoleRoute path={`${match.path}/clients/:id?`}>
						{auth(<Clients />)}
					</RoleRoute>
					<RoleRoute path={`${match.path}/external-applications/:id?`} exact>
						{auth(<ExternalApplications />)}
					</RoleRoute>
					<RoleRoute path={`${match.path}/settings`}>
						{auth(<SettingsApp />)}
					</RoleRoute>
					<RoleRoute path={`${match.path}/candidates/profile/:id/edit`}>
						{auth(<CandidateProfile isEdit={true} />)}
					</RoleRoute>
				</div>
			</div>
		</>
	);
};

function auth(component) {
	if (!authStore.isUserLogged()) {
		return <Redirect to="/login" />;
	} else {
		return component;
	}
}

export default withRouter(ATSRoutes);
